import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import DefaultView from "./views/DefaultView.vue";
import DashboardView from "./views/DashboardView.vue";
import CreateRequestView from "./views/CreateRequestView.vue";
import ViewDetailsView from "./views/ViewDetailsView.vue";
import EditDetailsView from "./views/EditDetailsView.vue";
import store from "./store";
import security from "./utils/msalUtil";

Vue.use(Router);

async function checkAuth(to, from, next) {
  if (!store.getters.isAuthenticated) {
    NProgress.start();
    var tokenResponse = await security.acquireTokenSilent();
    if (tokenResponse === null) {
      window.location.href = "/";
    } else {
      store.commit("login", tokenResponse.token);
      store.commit("user", {
        user: tokenResponse.account,
      });
      NProgress.done();
      next();
    }
  } else {
    next();
  }
}
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/default", ///:lawfirm?",
      name: "default-view",
      component: DefaultView,
      beforeEnter: checkAuth,
    },
    {
      path: "/dashboard",
      name: "dashboard-view",
      component: DashboardView,
      beforeEnter: checkAuth,
    },
    {
      path: "/createrequest",
      name: "create-request-view",
      component: CreateRequestView,
      beforeEnter: checkAuth,
    },
    {
      path: "/request/:requestid/details",
      name: "request-details-view",
      component: ViewDetailsView,
      beforeEnter: checkAuth,
    },
    {
      path: "/request/:requestid/edit",
      name: "edit-details-view",
      component: EditDetailsView,
      beforEnter: checkAuth,
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
    {
      path: "*",
      component: () => import(/* webpackChunkName: "about" */ "./views/404.vue"),
    },
  ],
});
